import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { setActiveBrand } from "../store/slices/brandSwitcherSlice";
import { fetchBrands, BrandOption } from "../services/api";

function decodeJwtBrandSlug(token: string | null): string | null {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.data?.brand_slug ?? null;
  } catch {
    return null;
  }
}

const BrandSwitcher: React.FC = () => {
  const dispatch = useDispatch();
  const token = useSelector((s: RootState) => s.auth.token);
  const activeSlug = useSelector((s: RootState) => s.brandSwitcher.activeSlug);
  const [brands, setBrands] = useState<BrandOption[]>([]);

  const jwtBrandSlug = decodeJwtBrandSlug(token);
  const isSuperAdmin = !jwtBrandSlug;

  useEffect(() => {
    if (isSuperAdmin) {
      fetchBrands().catch(() => []).then(setBrands);
    }
  }, [isSuperAdmin]);

  if (!isSuperAdmin) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: "4px 10px",
          background: "var(--surface-2, rgba(0,0,0,.06))",
          borderRadius: 6,
          fontSize: 12,
          fontWeight: 500,
          color: "var(--text-2, rgba(0,0,0,.55))",
        }}
      >
        <span
          style={{
            width: 7,
            height: 7,
            borderRadius: "50%",
            background: "var(--color-primary, #6366f1)",
            flexShrink: 0,
          }}
        />
        {jwtBrandSlug}
      </div>
    );
  }

  return (
    <select
      value={activeSlug ?? ""}
      onChange={(e) => dispatch(setActiveBrand(e.target.value || null))}
      style={{
        padding: "4px 10px",
        borderRadius: 6,
        border: "1px solid var(--border, rgba(0,0,0,.15))",
        background: "var(--surface-1, #fff)",
        fontSize: 12,
        fontWeight: 500,
        cursor: "pointer",
        color: "inherit",
        outline: "none",
        minWidth: 130,
      }}
      title="Filter by brand (super-admin)"
    >
      <option value="">All brands</option>
      {brands.map((b) => (
        <option key={b.slug} value={b.slug}>
          {b.name}
        </option>
      ))}
    </select>
  );
};

export default BrandSwitcher;
